import { render, staticRenderFns } from "./LmDocumentsMovements.vue?vue&type=template&id=c3a1e460"
import script from "./LmDocumentsMovements.vue?vue&type=script&lang=js"
export * from "./LmDocumentsMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports